import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Grid } from 'semantic-ui-react'

import Header from '../components/Header'
import Footer from '../components/Footer'

import '../styles/semantic.css'
import '../styles/site.scss'
import './index.scss'

import favicon from '../assets/images/favicon.png'

const TemplateWrapper = ({ children, data }) => (
  <div className='full-container'>
    <Helmet
      title="Closet Minimal"
      meta={[
        { name: 'description', content: 'Closet Minimal' },
        { name: 'keywords', content: 'clothing, menswear, minimal' },
      ]}
    >
      <link rel='icon' type='image/png' href={favicon} />
    </Helmet>
    <Grid columns={1} className='app-root'>
      <Grid.Row>
        <Grid.Column>
          <Header />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row stretched>
        <Grid.Column>
          {children()}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row verticalAlign='bottom'>
        <Grid.Column>
          <Footer />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js